/* eslint-disable camelcase */
/*
 *
 * Appointment actions
 *
 */

import {
  FETCH_THERAPISTS,
  FETCH_THERAPISTS_SUCCESS,
  FETCH_THERAPISTS_FAILURE,
  FETCH_THERAPIST_REVIEWS,
  FETCH_THERAPIST_REVIEWS_SUCCESS,
  FETCH_THERAPIST_REVIEWS_FAILURE,
  FETCH_THERAPIST_DETAIL,
  FETCH_THERAPIST_DETAIL_SUCCESS,
  FETCH_THERAPIST_DETAIL_FAILURE,
  SET_SELECTED_THERAPIST,
  TIP_THERAPIST,
  TIP_THERAPIST_SUCCESS,
  TIP_THERAPIST_FAILURE,
  CLEAR_TIP_THERAPIST_DATA,
  SET_TIPPED_APPOINTMENT,
  CLEAR_TIPPED_APPOINTMENT,
  RATE_THERAPIST,
  RATE_THERAPIST_SUCCESS,
  RATE_THERAPIST_FAILURE,
  FETCH_USER_THERAPISTS,
  FETCH_USER_THERAPISTS_SUCCESS,
  FETCH_USER_THERAPISTS_FAILURE,
  FAVORITE_THERAPIST,
  FAVORITE_THERAPIST_SUCCESS,
  FAVORITE_THERAPIST_FAILURE,
  UNFAVORITE_THERAPIST,
  UNFAVORITE_THERAPIST_SUCCESS,
  UNFAVORITE_THERAPIST_FAILURE,
  UPDATE_PRIVATE_NOTE,
  UPDATE_PRIVATE_NOTE_SUCCESS,
  UPDATE_PRIVATE_NOTE_FAILURE,
} from './constants';

export function fetchTherapists(locationId) {
  return {
    type: FETCH_THERAPISTS,
    locationId,
  };
}

export function fetchTherapistsSuccess(result) {
  return {
    type: FETCH_THERAPISTS_SUCCESS,
    result,
  };
}

export function fetchTherapistsFailure(error) {
  return {
    type: FETCH_THERAPISTS_FAILURE,
    error,
  };
}

export function fetchTherapistReviews(
  therapistId,
  offset,
  limit,
  userTherapist,
) {
  return {
    type: FETCH_THERAPIST_REVIEWS,
    therapistId,
    offset,
    limit,
    userTherapist,
  };
}

export function fetchTherapistReviewsSuccess(result) {
  return {
    type: FETCH_THERAPIST_REVIEWS_SUCCESS,
    result,
  };
}

export function fetchTherapistReviewsFailure(error) {
  return {
    type: FETCH_THERAPIST_REVIEWS_FAILURE,
    error,
  };
}

export function fetchTherapistDetail({ therapistId, userReviewsOnly }) {
  return {
    type: FETCH_THERAPIST_DETAIL,
    therapistId,
    userReviewsOnly,
  };
}

export function fetchTherapistDetailSuccess(result) {
  return {
    type: FETCH_THERAPIST_DETAIL_SUCCESS,
    result,
  };
}

export function fetchTherapistDetailFailure(error) {
  return {
    type: FETCH_THERAPIST_DETAIL_FAILURE,
    error,
  };
}

export function setSelectedTherapist(therapist) {
  return {
    type: SET_SELECTED_THERAPIST,
    therapist,
  };
}

export function tipTherapist({ therapist_id, tipType, amount, appointmentId }) {
  return {
    type: TIP_THERAPIST,
    therapist_id,
    tipType,
    amount,
    appointmentId,
  };
}

export function tipTherapistSuccess(result) {
  return {
    type: TIP_THERAPIST_SUCCESS,
    result,
  };
}

export function tipTherapistFailure(error) {
  return {
    type: TIP_THERAPIST_FAILURE,
    error,
  };
}

export function clearTipTherapistData() {
  return {
    type: CLEAR_TIP_THERAPIST_DATA,
  };
}

export function setTippedAppointment(appointment) {
  return {
    type: SET_TIPPED_APPOINTMENT,
    appointment,
  };
}

export function clearTippedAppointment() {
  return {
    type: CLEAR_TIPPED_APPOINTMENT,
  };
}

export function rateTherapist({
  therapist_id,
  appointment_id,
  rating,
  favorite,
  share_public,
  share_therapist,
  comment,
  private_note,
}) {
  return {
    type: RATE_THERAPIST,
    therapist_id,
    appointment_id,
    rating,
    favorite,
    share_public,
    share_therapist,
    comment,
    private_note,
  };
}

export function rateTherapistSuccess(result) {
  return {
    type: RATE_THERAPIST_SUCCESS,
    result,
  };
}

export function rateTherapistFailure(error) {
  return {
    type: RATE_THERAPIST_FAILURE,
    error,
  };
}

export function fetchUserTherapists() {
  return {
    type: FETCH_USER_THERAPISTS,
  };
}

export function fetchUserTherapistsSuccess(result) {
  return {
    type: FETCH_USER_THERAPISTS_SUCCESS,
    result,
  };
}

export function fetchUserTherapistsFailure(error) {
  return {
    type: FETCH_USER_THERAPISTS_FAILURE,
    error,
  };
}

export function favoriteTherapist(therapistId) {
  return {
    type: FAVORITE_THERAPIST,
    therapistId,
  };
}

export function favoriteTherapistSuccess(result) {
  return {
    type: FAVORITE_THERAPIST_SUCCESS,
    result,
  };
}

export function favoriteTherapistFailure(error) {
  return {
    type: FAVORITE_THERAPIST_FAILURE,
    error,
  };
}

export function unFavoriteTherapist(therapistId) {
  return {
    type: UNFAVORITE_THERAPIST,
    therapistId,
  };
}

export function unFavoriteTherapistSuccess(result) {
  return {
    type: UNFAVORITE_THERAPIST_SUCCESS,
    result,
  };
}

export function unFavoriteTherapistFailure(error) {
  return {
    type: UNFAVORITE_THERAPIST_FAILURE,
    error,
  };
}

export function updatePrivateNote(therapist_id, private_note) {
  return {
    type: UPDATE_PRIVATE_NOTE,
    therapist_id,
    private_note,
  };
}

export function updatePrivateNoteSuccess(result) {
  return {
    type: UPDATE_PRIVATE_NOTE_SUCCESS,
    result,
  };
}

export function updatePrivateNoteFailure(error) {
  return {
    type: UPDATE_PRIVATE_NOTE_FAILURE,
    error,
  };
}
